import { render, staticRenderFns } from "./UpdatePasswordDialog.vue?vue&type=template&id=c0cdfb08&scoped=true&"
import script from "./UpdatePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=c0cdfb08&scoped=true&lang=css&"
import style1 from "./UpdatePasswordDialog.vue?vue&type=style&index=1&id=c0cdfb08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cdfb08",
  null
  
)

export default component.exports